<template>
  <div class="brand-content">
    <template>
      <!-- <el-image
        class="banner"
        fit="cover"
        :src="require('@/assets/images/bjkj/首页-项目管理-资源库底色.jpg')"
      ></el-image> -->
      <div class="container">
        <h1 class="Small-title">
          <i class="iconfont iconpinpaizhanshi-kecheng pc"></i>
          <span>{{ data.name }}</span>
        </h1>
        <div class="info">主讲老师：{{ data.teachers }}</div>
        <div class="content">
          <preview :path="data.url" type="video" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import preview from "../components/preview.vue";
import { brandList } from "@/api/api.js";
import util from "@/libs/util.js";

export default {
  name: "brandContent",
  props: ["id"],
  data() {
    return {
      data: {},
    };
  },
  created() {
    // 获取资源信息
    this.getBrand();
    console.log(this.$route);
    console.log(this.id);
  },
  methods: {
    getBrand() {
      brandList()
        .then((res) => {
          // 处理数据
          console.log(res, "接口数据");
          let typeDatas = res.wholepageChapterDTOList;
          for (let i = 0; i < typeDatas.length; i++) {
            let orgDatas = typeDatas[i].wholepageItemDTOList;
            for (let j = 0; j < orgDatas.length; j++) {
              let orgData = orgDatas[j];

              for (let k = 0; k < orgData.wholepageDTOList.length; k++) {
                let brand = orgData.wholepageDTOList[k];
                let video = brand.coursepageDTOList[0];

                if (!video) {
                  continue;
                }

                if (this.id == video.parentid||parseInt(this.id) === video.resourceid) {
                  this.data = {
                    id: video.id,
                    name: brand.content,
                    cover: video.avatorFullurl,
                    url: video.resourceFullurl,
                    teachers: util.replaceTag(video.note),
                    school: orgData.title,
                  };
                  return;
                }
              }
            }
          }
          
        })
        .catch((err) => {
          // 异常情况
          console.log(err);
        });
    },
    download() {},
  },
  components: {
    preview,
  },
};
</script>

<style scoped>
.brand-content {
}
.banner {
  display: block;
  height: 140px;
}

.tjxd .banner {
  display: none;
}
.hnwgy .banner {
  display: none;
}

.container {
  position: relative;
  z-index: 2;
  margin-top: 40px;
  /* margin-top: -104px;*/
}

.tjxd .container {
  margin-top: 30px;
}
.hnwgy .container {
  margin-top: 30px;
}

h1 {
  font-size: 24px;
  line-height: 32px;
  color: #a52a2a;
}

.bjkj h1 {
  color: #9b3a0d;
}
.hnwgy h1 {
  color: #9b3a0d;
}

h1 .iconfont {
  margin-right: 10px;
  font-size: 24px;
}

.info {
  margin-left: 34px;
  margin-top: 16px;
  font-size: 14px;
  line-height: 16px;
}

.tjxd .info {
  color: unset;
}
.hnwgy .info {
  color: unset;
}

.content {
  margin-top: 74px;
  margin-bottom: 80px;
}

.tjxd .content {
  margin-top: 30px;
}
.hnwgy .content {
  margin-top: 30px;
}

@media (max-width: 767px) {
  .banner {
    height: 100px;
  }

  .container {
    margin-top: -80px;
  }

  h1 {
    font-size: 16px;
    line-height: 22px;
  }

  .info {
    margin-left: 0;
    font-size: 14px;
  }

  .content {
    margin-bottom: 30px;
  }
}
</style>
